// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAwfptlAZPRj8Hi2zHIhfhEr4DKzSkA-dE",
  authDomain: "vendedor-1664a.firebaseapp.com",
  projectId: "vendedor-1664a",
  storageBucket: "vendedor-1664a.appspot.com",
  messagingSenderId: "393481192816",
  appId: "1:393481192816:web:fdadeb775b1422fd377bb5",
  measurementId: "G-CHZHP8VPVN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, auth, db, storage }; 